export default import.meta.ROLLDOWN_FILE_URL_X0J0VmbE9Y6eehvFaNyYWw